<template>
  <a-modal
    title="手动周期"
    class="perid-modal"
    :width="800"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="vertical" :model="model" v-bind="{labelCol: { span: 24 },wrapperCol: { span: 24 },}" ref="ruleForm" :rules="rules">
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-model-item
              prop="name"
              label="周期名称">
              <a-input placeholder="请输入周期名称" v-model="model.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              prop="baseDate"
              label="随访日期">
              <a-date-picker value-format='YYYY-MM-DD' v-model="model.baseDate" style="width: 100%;"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              prop="advanceDay"
              label="最大可提前天数">
              <a-input-number v-model="model.advanceDay" placeholder="请输入最大可提前天数" :min="0" :precision="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              prop="delayDay"
              label="最大可延迟天数">
              <a-input-number v-model="model.delayDay" placeholder="请输入最大可延迟天数" :min="0" :precision="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              prop="answerUnexpiredBl"
              label="允许未到期作答">
              <a-switch v-model='model.answerUnexpiredBl' checked-children="是" un-checked-children="否"  />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              prop="answerOverdueBl"
              label="允许过期作答">
              <a-switch v-model='model.answerOverdueBl' checked-children="是" un-checked-children="否"  />
            </a-form-model-item>
          </a-col>
        </a-row>
        <!--<a-row v-if="!model.id">-->
          <!--<a-col :span="12">-->
            <!--<a-form-model-item-->
              <!--prop="text"-->
              <!--label="复用已有方案">-->
              <!--<a-input placeholder="请输入字典项文本" v-model="model.text" />-->
            <!--</a-form-model-item>-->
          <!--</a-col>-->
        <!--</a-row>-->
        <a-row>
          <a-transfer
            :disabled="!!model.id"
            :listStyle="{
            // width:'400px',
            width:'47%',
            height:'500px'
            }"
            :dataSource="formList"
            show-search
            :titles="['可选表单', '当前选择']"
            :filter-option="filterOption"
            :target-keys="targetKeys"
            :render="item => item.title"
            @change="handleChange"
            style="display: flex;align-items: center;justify-content: space-between;"
          />
        </a-row>
        <a-row style="margin-top: 20px">
          <a-col :span="12" style="text-align: left">
            <a-button type="danger" @click="deleteHandle" v-if="model.id">删除</a-button>
          </a-col>
          <a-col :span="12" style="text-align: right">
            <a-button @click="handleCancel" style="margin-right: 20px">取消</a-button>
            <a-button type="primary" @click="submitHandle">确定</a-button>
          </a-col>
        </a-row>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { postAction,getAction ,deleteAction} from '@/api/manage'
  import baseRules from '@/constants/baseRules'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'PeriodModal',
    props:['patientId'],
    data(){
      return{
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        visible: false,
        confirmLoading:false,
        model: {},
        rules:{
          name:[baseRules.required],
          baseDate:[baseRules.required],
          advanceDay:[baseRules.required],
          delayDay:[baseRules.required],
        },
        formList:[],
        targetKeys:[],
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        getAction('/project/projectForm/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            const formList = []
            res.result.forEach(item=>{
              formList.push({
                title:item.name,
                key:item.id
              })
            })
            this.formList = formList
          }
        })
      },
      add(){
        this.edit({})
      },
      edit(record,formList){
        record.period = '1'
        record.halfway = '1'
        record.answerUnexpiredBl = record.answerUnexpired==='1'
        record.answerOverdueBl = record.answerOverdue==='1'
        record.itemList = record.itemList||[]
        if(formList && formList.length>0){
          const targetKeys = []
          formList.forEach(form=>{
            targetKeys.push(form.baseFormId)
          })
          this.targetKeys = targetKeys
        }
        else{
          this.targetKeys = []
        }
        this.model = JSON.parse(JSON.stringify(record))
        this.visible = true
      },

      deleteHandle(){
        this.$confirm({
          title: '提示',
          content: '真的要删除吗 ?',
          onOk:()=> {
            this.confirmLoading = true;
            deleteAction("/patient/patientPeriodItem/delete", {id:this.model.id}).then((res)=>{
              if(res.success){
                this.$message.success(res.message);
                this.$emit('ok');
                this.handleCancel()
              }else{
                this.$message.warning(res.message);
              }
            }).finally(() => {
              this.confirmLoading = false;
            })
          },
          onCancel() {
          },
        });

      },
      submitHandle(){
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            that.model.answerUnexpired = that.model.answerUnexpiredBl?'1':'0'
            that.model.answerOverdue = that.model.answerOverdueBl?'1':'0'
            if(this.targetKeys.length===0){
              return this.$message.warning('请选择表单')
            }
            that.model.projectId = this.projectId
            that.model.patientId = this.patientId
            that.confirmLoading = true;
            const formList = []
            this.targetKeys.forEach(id=>{
              formList.push({id:id})
            })
            that.model.formList = formList
            postAction("/patient/patientPeriodItem/saveOrUpdate", that.model).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
                this.handleCancel()
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }else{
            return false;
          }
        })
      },
      handleCancel(){
        this.visible=false
      },
      filterOption(inputValue, option) {
        return option.name.indexOf(inputValue) > -1;
      },
      handleChange(targetKeys, direction, moveKeys) {
        // console.log(targetKeys, direction, moveKeys);
        this.targetKeys = targetKeys;
      },
    }
  }
</script>

<style scoped lang="less">

.perid-modal{
  /deep/ .ant-modal{
    background:#f5f6fa url(~@/assets/bg03.png) center top no-repeat;
    background-size: contain;
  }
  /deep/ .ant-modal-content,
  /deep/ .ant-modal-header
  {
    background-color: transparent;
  }

  /deep/ .ant-input,
  /deep/ .ant-input-number {
    border-radius: 12px;
  }

  /deep/ .ant-input-number-handler-up {
    border-top-right-radius: 12px;
  }

  /deep/ .ant-input-number-handler-down {
    border-top-right-radius: 12px;
  }

}

</style>